(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('picture', {
            parent: 'app',
            url: '/picture',
            data: {
                authorities: [],
                pageTitle: 'platformAppTitle.picture'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/picture/picture.html',
                    controller: 'PictureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('title');
                    return $translate.refresh();
                }]
            }
        })
        .state('picture1', {
            parent: 'app',
            url: '/picture1/{id}',
            data: {
                authorities: [],
                pageTitle: 'platformApp.productXml.home.title'
            },
            views: {
                'content': {
                    templateUrl: 'app/entities/picture/picture.html',
                    controller: 'PictureController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('fontManagement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('picture-xml', {
                url: '/picture-xml',
                data: {
                    authorities: [],
                    pageTitle: 'platformApp.productXml.home.title'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/picture/picture-xml.html',
                        controller: 'PictureXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: [function() {
                        return null;
                    }],
                }
            })
            .state('picture-xml-edit', {
                url: '/picture-xml-edit/{id}',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.picture-xml-edit'
                },
                views: {
                    'navbar@': {
                        templateUrl: 'app/entities/picture/picture-xml.html',
                        controller: 'PictureXmlController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['PicLayoutXmls','$stateParams', function(PicLayoutXmls,$stateParams) {
                        return PicLayoutXmls.get({id: $stateParams.id}).$promise;
                    }],
                }
            })
            .state('picture-share', {
                parent: 'app1',
                url: '/picture-share?page&sort&search&catalogId&selectedAll',
                data: {
                    authorities: [],
                    pageTitle: 'platformAppTitle.picture-share'
                },
                views: {
                    'content1': {
                        templateUrl: 'app/entities/picture/picture-share.html',
                        controller: 'PictureShareController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null,
                    catalogId: null,
                    selectedAll: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            catalogId: $stateParams.catalogId,
                            selectedAll: $stateParams.selectedAll,
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('fontManagement');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('title');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
